import React, { useCallback } from 'react';

import { getWorkEquipmentList } from 'api/hs/work-equipment/work-equipment';
import HSTableAndPaginationAndTableContextProvider from 'Common/Table/HSTable/HSTableAndPaginationAndTableContextProvider';

import { HSTableProps } from '../../../../Common/Table/HSTable/hs-table.props';
import EditDialog from '../EditDialog';
import { COLUMNS } from './columns';
import ListTable from './ListTableData';
import Toolbar from './Toolbar';

export default function WorkEquipmentDefinitionList() {
  const fetchWorkEquipmentList = useCallback<HSTableProps<any>['fetcher']>((page, size, sorting, extra) => {
    return getWorkEquipmentList(
      page,
      size,
      sorting === false ? null : `${sorting.id as string}-${sorting.direction.toUpperCase()}`,
      extra.filters ?? {}
    );
  }, []);

  return (
    <>
      <HSTableAndPaginationAndTableContextProvider fetcher={fetchWorkEquipmentList} columns={COLUMNS}>
        <Toolbar />
        <ListTable />
        <EditDialog />
      </HSTableAndPaginationAndTableContextProvider>
    </>
  );
}
